import { Component, OnInit } from '@angular/core';
import { DataTable } from 'primeng/primeng';
import { ConfirmationService, LazyLoadEvent, Message, SelectItem } from 'primeng/api';
import { CategoryGroup } from '../../../../models/inModels/CategoryGroup';
import { ActivatedRoute, Router } from '@angular/router';
import { BusinessService } from '../../../../services/business/business-category.service';
import { AuthenticationService } from '../../../../services/authentication/authentication.service';
import { StorageService } from '../../../../services/system/storage.service';

@Component({
  selector: 'app-category-group',
  templateUrl: './category-group.component.html',
  styleUrls: ['./category-group.component.css']
})
export class CategoryGroupComponent implements OnInit {
  loading: boolean;
  messages: Message[];
  group: CategoryGroup[];
  rows: SelectItem[];
  error: Message[];
  rowEvent: LazyLoadEvent;
  totalRecords: number;
  filteredRecords: number;
  selectedRows: number;
 
 
  constructor(
    private rout: ActivatedRoute,
    private router: Router,
    private businessService: BusinessService,
    private confirmationService: ConfirmationService,
    private auth: AuthenticationService,
    public storageService: StorageService
  ) { 
    this.loading = true;
    this.rows = [];
    this.rows.push({ label: '10', value: 10 });
		this.rows.push({ label: '25', value: 25 });
		this.rows.push({ label: '50', value: 50 });
		this.selectedRows = 10;
  }

  ngOnInit() {
  }

  changeRows(event): void {
    this.loadGroups(this.rowEvent);
  }

  reset(dt: DataTable, gb: HTMLInputElement) {
    gb.value = '';
    dt.reset();
  } 

  loadGroups(event: LazyLoadEvent): void {
    this.loading = true;
      event.rows = this.selectedRows;
      this.rowEvent = event;
      this.businessService.searchGroup(event).then(
        dataPager => {
          this.group = dataPager.Data;
          this.filteredRecords = dataPager.FilteredRecords;
          this.totalRecords = dataPager.TotalRecords;
          this.loading = false;
        },
        error => {
          this.loading = false;
          console.log(error);
          this.group = [];
          this.totalRecords = 0;
          this.filteredRecords = 0;
          this.error = [];
          this.error.push({ severity: 'error', summary: 'Error', detail: error });
        }
      );
    
  }
 
  delete(group: CategoryGroup) {
    console.log(group);
    this.confirmationService.confirm({
      message: `Are you sure you want to delete ${group.Name}?`,
      header: 'Confirmation',
      icon: 'fa fa-trash-o',
      accept: () => {
        this.loading = true;
        this.businessService.deleteGroup(group.Id).then(
          result => {
            this.loading = false;
            this.loadGroups(this.rowEvent);
          },
          error => {
            this.loading = false;
            this.error = [];
            this.error.push({ severity: 'error', summary: 'Error', detail: error });
          });
      }
    })
  }
  
  edit(group: CategoryGroup) {
		console.log(group);
		this.router.navigate(['business-category/groups/edit', group.Id]);
	}

}



// WEBPACK FOOTER //
// ./src/app/components/business/business-category/category-group/category-group.component.ts